import { render, staticRenderFns } from "./DanhSachGroup.vue?vue&type=template&id=20931586&"
import script from "./DanhSachGroup.vue?vue&type=script&lang=js&"
export * from "./DanhSachGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports